import { render, staticRenderFns } from "./TabletPainsSection.vue?vue&type=template&id=8b740af8&scoped=true"
import script from "./TabletPainsSection.vue?vue&type=script&lang=js"
export * from "./TabletPainsSection.vue?vue&type=script&lang=js"
import style0 from "./TabletPainsSection.vue?vue&type=style&index=0&id=8b740af8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b740af8",
  null
  
)

export default component.exports